<template>
  <el-table-wrapper border ref="detailTable" :data="reportList" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool"
      :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange"
      @selection-change="changeHandleSelection" style="width:100%;">
    <template slot-scope="scope" slot="slot">
      <span class="link" @click="clickReport(scope.row.reportId)">{{ scope.row.reportName }}</span>
    </template>
  </el-table-wrapper>
</template>

<script>
import map from 'lodash/map';
import { mapGetters } from 'vuex';
import reportApi from '@/api/report/report';
import { getDateToString } from '@/utils/date';
import { getPeriodTypeToString } from '@/utils/report';
import { routePath } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { columnDefault } from '@/constants/table';

const periodTypeFilters = [
  { text: '일간', value: 'D' },
  { text: '주간', value: 'W' },
  { text: '월간', value: 'M' },
  { text: '분기', value: 'Q' },
  { text: '반기', value: 'H' },
  { text: '연간', value: 'Y' },
];
const autoCreateFlagFilters = [
  { text: '활성', value: 'Y' },
  { text: '비활성', value: 'N' },
];

export default {
  name: 'WReportDetailTable',
  props: {
    orderType: {
      type: String,
      default: () => 'count',
    },
    viewType: {
      type: String,
      default: () => 'icon',
    },
    active: {
      type: Boolean,
      defulat: () => false,
    },
    showSearchTool: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      columnDefault,
      total: null,
      reportList: [],
      selectedReport: [],
      columns: [
        { type: 'selection' },
        { prop: 'reportName', label: '보고서명', scopedSlot: 'slot', searchable: true, remoteProp: 'report_name' },
        { prop: 'registDatetime', label: '생성날짜', searchable: true, searchType: 'date', formatter: this.convertDatetime, remoteProp: 'ri.regist_datetime' },
        { prop: 'printCount', label: '출력 횟수', width: '70px' },
        { prop: 'managerName', label: '생성자', searchable: true, remoteProp: 'manager_name' },
        { prop: 'periodType', label: '기준기간', width: '100px', formatter: this.getPeriodType, remoteProp: 'period_type', filterMultiple: false, filters: periodTypeFilters },
        { prop: 'autoCreateFlag', label: '스케줄링', width: '100px', filterMultiple: false, filters: autoCreateFlagFilters, formatter: this.getAutoCreateFlag, remoteProp: 'auto_create_flag' },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    orderType: {
      handler() {
        this.loadData();
      },
    },
    active: {
      handler(active) {
        if (active) {
          this.loadData();
        }
      },
    },
    viewType: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
  },
  methods: {
    getDateToString,
    loadData() {
      if (this.viewType === 'detail') {
        const tableParams = this.$refs.detailTable.getParameter();
        const params = {
          orderType: this.orderType,
          reportTmplId: this.selectedNode.reportTmplId,
          ...tableParams,
        };
        reportApi.gerReportList(params).then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            this.reportList = response.data.data;
          }
        });
      }
    },
    changeHandleSelection(selectVal) {
      this.selectedReport = selectVal;
    },
    getSelectedReportList() {
      return map(this.selectedReport, (data) => ({ reportTmplId: data.reportTmplId, reportId: data.reportId }));
    },
    convertDatetime(row, column, value) {
      return getDateToString(value);
    },
    getPeriodType(row, column, value) {
      return getPeriodTypeToString(value);
    },
    getAutoCreateFlag(row, column, value) {
      let flagStr = '비활성';
      if (value === 'Y') {
        flagStr = '활성';
      }
      return flagStr;
    },
    clickReport(reportId) {
      routePath(this, menuDefine.REPORT, `${this.selectedNode.treeKey}.${reportId}`);
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/template/list/components/ReportDetailTable.vue